import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useDeleteMatter = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (matterId: string) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
      });

      const res = await fetch(`${APIBaseChronos}/api/matters/${matterId}`, fetchConfig);

      if (!res.ok) {
        const error = await res.json();
        throw new Error(error.message || 'Failed to delete Matter');
      }

      return matterId;
    },
    onSuccess: () => {
      toast.success('Matter deleting...');
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Matters] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Matter] });
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to delete Matter. Please try again.');
    },
  });
};
